// The Odds API — https://the-odds-api.com (free tier: 500 req/month)
// Mettre la clé ici (ou dans une variable d'env REACT_APP_ODDS_KEY)
const ODDS_API_KEY =
  (process.env.REACT_APP_ODDS_KEY as string) || "";

const SPORT = "soccer_fifa_world_cup";

export interface MatchOdds {
  t1: string;
  t2: string;
  p1: number;
  pX: number;
  p2: number;
}

function decimalToProb(h: number, d: number, a: number): [number, number, number] {
  const raw = [1 / h, 1 / d, 1 / a];
  const sum = raw.reduce((s, v) => s + v, 0);
  return raw.map((v) => Math.round((v / sum) * 100) / 100) as [number, number, number];
}

function avg(arr: number[]): number {
  return arr.reduce((s, v) => s + v, 0) / arr.length;
}

export async function fetchLiveOdds(): Promise<MatchOdds[]> {
  if (!ODDS_API_KEY) return [];
  try {
    const res = await fetch(
      `https://api.the-odds-api.com/v4/sports/${SPORT}/odds/?apiKey=${ODDS_API_KEY}&regions=eu&markets=h2h&dateFormat=iso&oddsFormat=decimal`
    );
    if (!res.ok) return [];
    const data: any[] = await res.json();

    return data.flatMap((event) => {
      const home = event.home_team as string;
      const away = event.away_team as string;

      const homeOdds: number[] = [];
      const drawOdds: number[] = [];
      const awayOdds: number[] = [];

      (event.bookmakers ?? []).forEach((bm: any) => {
        const market = bm.markets?.find((mk: any) => mk.key === "h2h");
        if (!market) return;
        market.outcomes.forEach((o: any) => {
          if (o.name === home) homeOdds.push(o.price);
          else if (o.name === away) awayOdds.push(o.price);
          else drawOdds.push(o.price);
        });
      });

      if (!homeOdds.length || !drawOdds.length || !awayOdds.length) return [];
      const [p1, pX, p2] = decimalToProb(avg(homeOdds), avg(drawOdds), avg(awayOdds));
      return [{ t1: home, t2: away, p1, pX, p2 }];
    });
  } catch {
    return [];
  }
}
